import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let AmBizVoice = class AmBizVoice extends Vue {
  change() {
    this.$emit('change');
  }
};
AmBizVoice.componentName = 'AmBizVoice';
__decorate([Prop({
  default: 0
})], AmBizVoice.prototype, "second", void 0);
__decorate([Prop({
  default: false
})], AmBizVoice.prototype, "isPlay", void 0);
__decorate([Prop()], AmBizVoice.prototype, "text", void 0);
AmBizVoice = __decorate([Component({
  name: 'AmBizVoice'
})], AmBizVoice);
export default AmBizVoice;